import imageCompression from 'browser-image-compression';

const MAX_SIZE_MB = 1;
const MAX_WIDTH_OR_HEIGHT = 1920; // Full HD
const QUALITY = 0.8;

export const compressImage = async (file) => {
  if (!file?.type?.startsWith('image/')) return file;

  try {
    return await imageCompression(file, {
      maxSizeMB: MAX_SIZE_MB,
      maxWidthOrHeight: MAX_WIDTH_OR_HEIGHT,
      initialQuality: QUALITY,
      useWebWorker: true,
    });
  } catch {
    // If compression fails (e.g. an unsupported format), fall back to the original file
    // rather than blocking the upload.
    return file;
  }
};

export const compressImages = (files) => Promise.all(Array.from(files).map(compressImage));
